import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './ReservationSummaryImage.scss';

const ReservationSummaryImage = ({
  backgroundImage,
  card,
  large,
}) => (
  <div
    className={cx('ReservationSummaryImage', {
      ReservationSummaryImage__xs: card,
      ReservationSummaryImage__largeImage: large,
    })}
    style={{
      backgroundImage: `url(${backgroundImage})`,
    }}
  />
);

ReservationSummaryImage.propTypes = {
  backgroundImage: PropTypes.string,
  card: PropTypes.bool,
  large: PropTypes.bool,
};

ReservationSummaryImage.defaultProps = {
  backgroundImage: undefined,
  card: false,
  large: false,
};

export default ReservationSummaryImage;
